import React from 'react';
import { Box, Typography, TableRow, TableCell } from '@mui/material';
import { FileText } from 'lucide-react';

export default function EmptyState({ message = 'No data found', icon: Icon = FileText, colSpan = 8 }) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center" sx={{ py: 6, borderBottom: 'none' }}>
        <Box display="flex" flexDirection="column" alignItems="center" gap={1.5}>
          <Icon size={40} color="#2E3247" strokeWidth={1.5} />
          <Typography sx={{ color: '#64748B', fontSize: '0.9rem' }}>
            {message}
          </Typography>
        </Box>
      </TableCell>
    </TableRow>
  );
}
